module.exports = __webpack_public_path__ + "img/support3.69a18bcb.png";